import React__default from 'react';
import { KpkApiFormFieldType } from '@keepeek/api-client';
import { Box } from '@mui/material';
import FieldDateContainer from '../../KFImport/containers/FieldDateContainer/index.js';
import FieldListContainer from '../../KFImport/containers/FieldListContainer/index.js';
import FieldNumberContainer from '../../KFImport/containers/FieldNumberContainer/index.js';
import FieldSuggestionContainer from '../../KFImport/containers/FieldSuggestionContainer/index.js';
import FieldTextContainer from '../../KFImport/containers/FieldTextContainer/index.js';
import FieldThesaurusContainer from '../../KFImport/containers/FieldThesaurusContainer/index.js';

var ImportForm = function (_a) {
    var fields = _a.fields, KIcon = _a.KIcon;
    return (React__default.createElement(React__default.Fragment, null, fields.map(function (field) {
        var component;
        switch (field.type) {
            case KpkApiFormFieldType.Number:
                component = (React__default.createElement(FieldNumberContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
                break;
            case KpkApiFormFieldType.Date:
                component = (React__default.createElement(FieldDateContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
                break;
            case KpkApiFormFieldType.Thesaurus:
                component = (React__default.createElement(FieldThesaurusContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
                break;
            case KpkApiFormFieldType.MultipleList:
                component = (React__default.createElement(FieldSuggestionContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
                break;
            case KpkApiFormFieldType.SimpleList:
                component = (React__default.createElement(FieldListContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
                break;
            default:
                component = (React__default.createElement(FieldTextContainer, { testId: "inputfield-".concat(field.title), formField: field, invertColors: true, KIcon: KIcon }));
        }
        return (React__default.createElement(Box, { sx: { padding: function (theme) { return theme.spacing(0.5, 0); } }, key: field.id }, component));
    })));
};

export { ImportForm as default };
//# sourceMappingURL=ImportForm.js.map
